import {
  Box,
  Button,
  Drawer,
  FormControl,
  InputLabel,
  ListItemText,
  MenuItem,
  OutlinedInput,
  Select,
  Stack,
  TextField,
} from "@mui/material";
import FilterIcon from "src/assets/svg-icons/aggregators/filter.svg";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { useGetMenuCategories } from "src/api/inventory/menu";

interface IProps {
  isProduct: boolean;
  open: boolean;
  handleClose: any;
  name: string;
  setName: Function;
  sku: string;
  setSku: Function;
  type: string;
  setType: Function;
  category: string;
  setCategory: Function;
}

const FilterDrawer = (props: IProps) => {
  const { t } = useTranslation("purchasing");
  const { t: generalT } = useTranslation("general");
  const { t: inventoryT } = useTranslation("inventory");
  const {
    open,
    handleClose,
    name,
    setName,
    type,
    setType,
    sku,
    setSku,
    category,
    setCategory,
    isProduct,
  } = props;
  const [tempName, setTempName] = useState(name);
  const [tempSku, setTempSku] = useState(sku);
  const [tempType, setTempType] = useState(type);
  const [tempCategory, setTempCategory] = useState(category);

  // apis
  const { data, isFetching, refetch } = useGetMenuCategories();

  const handleApply = () => {
    handleClose();
    setName(tempName);
    setSku(tempSku);
    setType(tempType);
    setCategory(tempCategory);
  };

  const handleClearFilters = () => {
    handleClose();
    setName("");
    setSku("");
    setType("all");
    setCategory("");

    setTempName("");
    setTempSku("");
    setTempType("all");
    setTempCategory("");
  };

  const Types = [
    {
      label: generalT("all"),
      value: "all",
    },
    {
      label: t("fixedCost"),
      value: "fixed",
    },
    {
      label: inventoryT("recipeCost"),
      value: "recipe",
    },
  ];

  return (
    <Drawer anchor={"right"} open={open} onClose={handleClose}>
      <Stack
        maxWidth={{ xs: "100%", sm: "376px" }}
        minWidth={{ xs: "100%", sm: "376px" }}
        borderRight={"1px solid #D0D5DD"}
        height={"100%"}
        maxHeight={"100vh"}
        top={"0"}
      >
        <Box
          display={"flex"}
          justifyContent={"space-between"}
          p={"20px 27px"}
          bgcolor={"#fff"}
          boxShadow="0px 0px 40px 0px rgba(11, 24, 42, 0.07)"
        >
          <Button
            color="tertiary"
            variant="text"
            size="small"
            endIcon={<img src={FilterIcon} height={"16px"} alt="" />}
          >
            {t("filter")}
          </Button>
          <Button
            variant="outlined"
            color="tertiary"
            size="small"
            onClick={handleClose}
          >
            {t("hide")}
          </Button>
        </Box>
        <Stack spacing={"20px"} p={"40px 27px"}>
          {/* name */}
          <TextField
            label={t("name")}
            variant="outlined"
            size="small"
            fullWidth
            value={tempName}
            onChange={(e) => setTempName(e.target.value)}
          />
          {/* sku */}
          <TextField
            label={t("SKU")}
            variant="outlined"
            size="small"
            fullWidth
            value={tempSku}
            onChange={(e) => setTempSku(e.target.value)}
          />
          {/*  category Select */}
          {isProduct ? (
            <FormControl fullWidth size="small">
              <InputLabel id="demo-multiple-checkbox-label">
                {t("category")}
              </InputLabel>
              <Select
                labelId="demo-multiple-checkbox-label"
                id="demo-multiple-checkbox"
                value={tempCategory}
                onChange={(e) => setTempCategory(e.target.value)}
                input={<OutlinedInput label={t("category")} />}
              >
                <MenuItem value={"all"}>
                  <ListItemText primary={generalT("all")} />
                </MenuItem>
                {data?.data?.map((cat: any) => (
                  <MenuItem key={cat.id} value={cat.id}>
                    <ListItemText primary={cat.name} />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          ) : null}
          {/*  type */}
          <FormControl fullWidth size="small">
            <InputLabel id="demo-multiple-checkbox-label">
              {t("type")}
            </InputLabel>
            <Select
              labelId="demo-multiple-checkbox-label"
              id="demo-multiple-checkbox"
              value={tempType}
              onChange={(e) => setTempType(e.target.value)}
              input={<OutlinedInput label={t("type")} />}
            >
              {Types.map(({ label, value }) => (
                <MenuItem key={value} value={value}>
                  <ListItemText primary={label} />
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          {/* divider */}
          <Box width={"100%"} height={"1px"} bgcolor={"#CBD5E1"} />
        </Stack>
        <Box
          display={"flex"}
          justifyContent={"space-between"}
          p={"20px 27px"}
          bgcolor={"#fff"}
          boxShadow="0px 0px 40px 0px rgba(11, 24, 42, 0.07)"
          alignItems={"flex-end"}
          mt="auto"
        >
          <Button variant="contained" size="small" onClick={handleApply}>
            {generalT("apply")}
          </Button>
          <Button
            variant="outlined"
            color="tertiary"
            size="small"
            onClick={handleClearFilters}
          >
            {generalT("clear")}
          </Button>
        </Box>
      </Stack>
    </Drawer>
  );
};
export default FilterDrawer;
